import { AlgoliaDynamicCarouselItem } from "../types/carousel"
import { getAlgoliaClient, PRODUCTS_INDEX_NAME } from "../services/client"
import { toPartialGridItemProduct } from "../converters"
import { AlgoliaProductVariant } from "../types/doc"
import { toAlgoliaFilter, toAlgoliaNumericFilters } from "../api/filters"
import { PartialGridItemProduct } from "../../../ui/organisms/Product/ProductGridItem/types"

export interface FetchAlgoliaCarouselInput {
  item: AlgoliaDynamicCarouselItem
}

export const fetchAlgoliaCarouselItems = async (
  input: FetchAlgoliaCarouselInput
): Promise<PartialGridItemProduct[]> => {
  try {
    const results = await getAlgoliaClient().search<any>([
      {
        indexName: PRODUCTS_INDEX_NAME,
        params: {
          enablePersonalization: true,
          hitsPerPage: input.item.maxResults,
          filters: toAlgoliaFilter(
            {
              brandCodes: input.item.brands,
              categories: input.item.categories,
              tags: input.item.tags,
              excludeProductIds: input.item.exclude,
              promoCodes: input.item.promoCodes,
            },
            new Date()
          ),
          numericFilters: toAlgoliaNumericFilters({
            minPrice: input.item.price?.from,
            maxPrice: input.item.price?.to,
          }),
          userToken: input.item.userToken,
        },
      },
    ])
    return results.results[0].hits.map((x: AlgoliaProductVariant) =>
      toPartialGridItemProduct(x)
    )
  } catch (e) {
    console.error("Error searching algolia carousel items", e)
    return []
  }
}
